// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accordion__wrapper2Oi","trigger":"accordion__trigger1GX","trigger--active":"accordion__trigger--active1vp","content":"accordion__contentvMn"};